import { IChangePassFormValues } from "../Interfaces/headerInterfaces";
import { Packet } from "../Interfaces/commonDtos";
import { ICurrentUserInfo } from "../Interfaces/customerReport";
import { getRequest, putRequest } from "./requestTemplates";

export const getCurrentUserInfo = (): Promise<ICurrentUserInfo> =>
  getRequest("/v1/CustomerReport/CurrentUserInfo");

export const changeCustomerPassword = (
  formValues: IChangePassFormValues,
): Promise<Packet<boolean>> =>
  putRequest("/v1/CustomerReport/changePassword", formValues);
